import Splide from '@splidejs/splide'
import GLightbox from 'glightbox'

export default (opts = {}, count = 3) => ({
  opts: {
    perPage: 3,
    perMove: 1,
    pagination: false,
    arrows: count > 3,
    arrowPath: 'M11.7727 40L31.4633 20.075L11.7727 0L9.99634 1.7975L28.207 20.075L9.99634 38.2025L11.7727 40Z',
    breakpoints: {
      640: {
        perPage: 1,
        arrows: count > 1,
      },
      768: {
        perPage: 2,
        arrows: count > 2,
      },
    },
    ...opts,
  },
  splide: null,
  lightbox: null,
  currentIndex: 0,

  init() {
    if (this.splide !== null) {
      return
    }

    this.splide = new Splide(this.$el, this.opts).mount()

    this.splide.on('mounted move', () => {
      this.currentIndex = this.splide.index
    })

    this.lightbox = GLightbox({
      selector: '[data-glightbox]',
      loop: true,
      openEffect: 'fade',
      closeEffect: 'fade',
      width: 1920,
      height: 1080,
    })

    this.lightbox.on('slide_changed', ({ prev, current }) => {
      // Update position of the slider
      this.splide.go( current.index )
    })

  },

  goTo(index) {
    this.splide.go(index)
  },

})
